import { Backend } from '../../../api/Backend';
import { Lightning } from '@lightningjs/sdk';

export class DetailAction {
  protected _backend: Backend;
  protected _owner: Lightning.Component | undefined;

  constructor(backend: Backend) {
    this._backend = backend;
    this._owner = undefined;
  }

  set owner(val: Lightning.Component | undefined) {
    this._owner = val;
  }

  get owner(): Lightning.Component | undefined {
    return this._owner;
  }

  doAction() {
    throw new Error('No action implemented');
  }
}
